import React from 'react';
import { useToastContext } from '../../contexts/ToastContext';
import { CheckCircle, XCircle, Info, AlertTriangle, X } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

const TOAST_STYLES = {
  success: {
    icon: CheckCircle,
    color: 'text-emerald-400',
    border: 'border-emerald-500/20',
  },
  error: {
    icon: XCircle,
    color: 'text-rose-400',
    border: 'border-rose-500/20',
  },
  info: {
    icon: Info,
    color: 'text-amber-400',
    border: 'border-amber-500/20',
  },
  warning: {
    icon: AlertTriangle,
    color: 'text-amber-400',
    border: 'border-amber-500/20',
  },
};

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToastContext();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-3 pointer-events-none max-w-md w-full sm:w-auto">
      {toasts.map((toast) => {
        const style = TOAST_STYLES[toast.type];
        const Icon = style.icon;

        return (
          <div
            key={toast.id}
            className={twMerge(
              'pointer-events-auto flex items-start gap-3 p-4 bg-slate-900/95 backdrop-blur-md border rounded-2xl shadow-2xl animate-in slide-in-from-right-full duration-300',
              style.border
            )}
          >
            <div className={twMerge('mt-0.5', style.color)}>
              <Icon size={20} />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-slate-100 leading-relaxed">{toast.message}</p>
            </div>
            <button
              onClick={() => removeToast(toast.id)}
              className="mt-0.5 text-slate-500 hover:text-slate-300 transition-colors"
            >
              <X size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
};
